import { render, staticRenderFns } from "./DatasetMenu.vue?vue&type=template&id=14befeab&"
import script from "./DatasetMenu.vue?vue&type=script&lang=js&"
export * from "./DatasetMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports